import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoginComponent } from '../login/login.component';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterModule, LoginComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit, OnDestroy {
  isCheckingAuth = true;
  private subscription = new Subscription();

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Verificar si el usuario ya está autenticado
    this.subscription.add(
      this.authService.isAuthenticated$.subscribe(isAuthenticated => {
        console.log('Home: isAuthenticated =', isAuthenticated);
        
        if (isAuthenticated) {
          console.log('Home: Usuario ya autenticado, redirigiendo a dashboard...');
          this.router.navigate(['/dashboard']);
        } else {
          // Mostrar la página home solo si no está autenticado
          this.isCheckingAuth = false;
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}